import { IResponse } from "..";
import client from "../client";
import tokenHandler from "../tokenHandler";

// SignUp
interface ISignUpRequest {
  email: string;
  password: string;
  firstname: string;
  lastname: string;
}

async function signUp(body: ISignUpRequest) {
  return client.post<IResponse<ITokenResponse>>("/auth/signup", body);
}

// Login variations
export interface ITokenResponse {
  access_token: string;
  refresh_token: string;
  userCreation: boolean;
}

async function login(email: string, password: string) {
  return client.post<IResponse<ITokenResponse>>("/auth/login", {
    email,
    password,
  });
}

async function loginToken(token: string) {
  return client.post<IResponse<ITokenResponse>>("/auth/login/token", {
    token,
  });
}

async function oAuth(provider: string, code: string) {
  return client.post<IResponse<ITokenResponse>>(
    `/auth/oauth/callback?provider=${provider}&code=${code}`
  );
}

// OAuth url
interface IUrlResponse {
  targetUrl: string;
}

async function getOAuthURL(provider: string, target: string | null) {
  return client.get<IResponse<IUrlResponse>>(
    `/auth/oauth/url?provider=${provider}${target ? `&target=${target}` : ""}`
  );
}
async function getSSORedirectUrl(provider: string, target: string | null) {
  return client.get<IResponse<IUrlResponse>>(
    `/auth/oauth/redirectUrl/${target}?provider=${provider}`
  );
}

// Logout
async function logout() {
  return client.post(`/auth/logout`, {
    refresh_token: tokenHandler.getRefreshToken(),
  });
}

const api = {
  login,
  loginToken,
  signUp,
  logout,
  oAuth,
  getOAuthURL,
  getSSORedirectUrl,
  // refresh
};

export default api;
